module.exports = __webpack_public_path__ + "images/vgz11aa4c8632ee1d68d6197f9d12b14c10.png";